export default __webpack_public_path__ + "static/media/radicalx-internships.ff92816d.png";